var _ellipse, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon100101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8,
    cy: 12.8,
    rx: 12.8,
    ry: 12.8,
    fill: "#8A066A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 7V10.8519L11.1001 15V11.5926L7.1001 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.4L11.1 15.4582V14.9L9.48276 13.4L7 16.1907V19.4Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1001 7V10.8519L18.1001 15V11.5926L14.1001 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.4L18.1 15.4582V14.9L16.4828 13.4L14 16.1907V19.4Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon100101);
export default __webpack_public_path__ + "static/media/icon-100-10-1.bfed658d2c8815fce1b6a41da4de1363.svg";
export { ForwardRef as ReactComponent };